__webpack_require__.p = "/mi-assets/mi-static/mi-homepage-renderer/web-rel-26.7.1-07132026330/_next/";